
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class ExpandingUniverseEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const points = Math.floor(100 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const draw = () => {
             ctx.save();
             ctx.globalAlpha *= 0.8 / (layerIndex + 1);
             ctx.beginPath();
            for (let i = 0; i < points; i++) {
                const life = (curTime * 0.1 + i / points) % 1;
                const dist = life * Math.max(width, height) * 2 * scale;
                const angle = this.pseudoRandom(i) * Math.PI * 2;
                
                const px = Math.cos(angle) * dist;
                const py = Math.sin(angle) * dist;
                const size = life * 5 * scale;
                
                ctx.moveTo(px + size, py);
                ctx.arc(px, py, size, 0, Math.PI * 2);
            }
            ctx.fill();
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
